import { observer } from 'mobx-react-lite';
import { Trash2 } from 'lucide-react';
import { useStore } from '@shared/hooks/useStore';
import { formatDateTime } from '@shared/utils/datetime';
import { DATE_TIME_FULL } from '@shared/components/constants/common.constants';

interface ReaderBookmarkListProps {
    onItemClick: (pageNumber: number) => void,
    onDelete: (id: string) => void
}

const ReaderBookmarkList = observer(({ onItemClick, onDelete }: ReaderBookmarkListProps) => {
    const { readerStore } = useStore();

    return (
        <div className='flex flex-col gap-4'>
            {readerStore.bookmarks.map(bookmark => (
                <div key={bookmark.id} className='flex flex-col'>
                    <div
                        className='cursor-pointer group mb-1'
                        onClick={() => onItemClick(bookmark.pageNumber)}
                    >
                        <h4 className='text-sm font-semibold mb-1 leading-[26px] transition-colors'>
                            {bookmark.pageNumber}
                            ページ
                        </h4>
                        <p className='text-[11px] leading-[22px] line-clamp-3'>
                            {bookmark.content}
                        </p>
                    </div>
                    <div className='flex justify-between items-center'>
                        <span className='text-[11px] leading-[22px] text-[#FFFFFF80]'>{formatDateTime(bookmark.createdAt, DATE_TIME_FULL)}</span>
                        <button
                            onClick={() => onDelete(bookmark.id)}
                            className='text-white transition-colors'
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                    <div className='h-[1px] bg-[#FFFFFF1A] mt-4' />
                </div>
            ))}

            {readerStore.bookmarks.length < readerStore.bookmarkTotal && (
                <button
                    onClick={() => readerStore.fetchBookmarks(true)}
                    disabled={readerStore.isFetchingBookmarks}
                    className='w-full py-2 bg-[#FFFFFF0A] hover:bg-[#FFFFFF1A] transition-colors rounded-[4px] text-[13px] font-medium'
                >
                    {readerStore.isFetchingBookmarks ? '読み込み中...' : 'もっと見る'}
                </button>
            )}
        </div>
    );
});

export default ReaderBookmarkList;
